// extracted by mini-css-extract-plugin
export default {"banner":"ConnectionBanner_banner__-eSDY","bannerEnter":"ConnectionBanner_bannerEnter__QfI0U","icon":"ConnectionBanner_icon__C8Rn-","text":"ConnectionBanner_text__buinz"};